module.exports = __webpack_public_path__ + "UX30.png?6ef95ec8a003c814b13ae85689b4b8dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX30.png
// module id = 6
// module chunks = 0